import Base64 from 'crypto-js/enc-base64';
import HmacSHA256 from 'crypto-js/hmac-sha256';
import { getEnv } from 'webmd-url';

const auth = {
	/**
	 * Get the default per environment
	 * @returns {object}
	 */
	getDefaults() {
		/*
		 * Hardcoded the subscribe API url to staging,
		 * So passing correct auth keys even on feature branch
		 * MAY NEED REPLACEMENT LATER ONCE WE HAVE ALL SET UP
		 *
		 */

		const testEnv = ['.feature', '.devint', '.qa', '.k8s'];
		const envVal = getEnv(window.location.href);
		const isStaging = window.location.href && window.location.href.includes('.staging.');

		// eslint-disable-next-line
		if (envVal === '' || testEnv.indexOf(envVal) !== -1) {
			/**
			 * Because staging is not longer point to production env we have
			 * to use client_id & client_secret from staging oauth
			 * https://jira.internetbrands.com/browse/PPE-365702
			 */
			if (isStaging) {
				return {
					client_id: '28c8b711-b6b8-440c-9e78-d56a1bcc4aa2',
					secret_key: '7a36664e-1b3b-42a1-ae39-9334b8d42d07',
				};
			}

			// Prod Keys
			return {
				client_id: '414a9d52-a427-48a1-99bd-78ed7afa9996',
				secret_key: '6a145282-d644-49ac-ac05-c85d26862e24',
			};
		}

		// non-prod keys
		return {
			client_id: '414a9d52-a427-48a1-99bd-78ed7afa9996',
			secret_key: 'ca7fed5b-7b54-4e34-8d98-ab2579eed686',
		};
	},

	/**
	 * Generates an oauth object to send with requests for solr search APIs
	 * @param {object} options
	 * @returns {object}
	 */
	generate(options) {
		const self = this;
		const settings = { ...self.getDefaults(), ...options };
		const timestamp = Math.floor(new Date().getTime() / 1000);
		let generatedOauth = {};
		let encData = Base64.stringify(HmacSHA256(
			`{timestamp:${timestamp},client_id:${settings.client_id}}`,
			settings.secret_key,
		));
		if (settings.isHashRequest) {
			encData = Base64.stringify(HmacSHA256(
				`{{timestamp:${timestamp},client_id:${settings.client_id}}}`,
				settings.secret_key,
			));
		}
		if (!Base64 || !HmacSHA256) {
			// webmd.debug('webmd.oauth error: CryptoJS module not loaded');
		} else {
			generatedOauth = {
				enc_data: encData,
				timestamp,
				client_id: settings.client_id,
				Accept: 'application/json',
			};
		}
		return generatedOauth;
	},
};
export default auth;
